<template>
<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-success`]" width="1em" height="1em" v-bind="$attrs"><path d="M6 0.75C8.8995 0.75 11.25 3.10051 11.25 6C11.25 8.8995 8.8995 11.25 6 11.25C3.10051 11.25 0.75 8.8995 0.75 6C0.75 3.10051 3.10051 0.75 6 0.75ZM8.58105 4.1709C8.3864 3.97643 8.07073 3.97658 7.87598 4.1709L5.27637 6.77051L4.12402 5.61816C3.92936 5.42369 3.61272 5.42383 3.41797 5.61816C3.22374 5.81286 3.22367 6.12859 3.41797 6.32324L4.92383 7.82812C5.11861 8.02278 5.43417 8.02285 5.62891 7.82812L8.58105 4.87598C8.77544 4.68118 8.77569 4.36555 8.58105 4.1709Z" :fill="useCurrentColor ? 'currentColor' : '#009A29'"/></svg>
</template>
<script>

export default {
  name: 'IconColorSuccess',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
